/**
 * Skafe Minimum Order gate (produtos, frete NÃO conta).
 *
 * Canonical product subtotal: Ajax Cart `/cart.js` `total_price` (centavos
 * inteiros, pós-descontos, sem frete — o frete só existe no checkout).
 * O valor mínimo e o texto vêm de `window.SkafeMinimumOrderConfig`, gerado em
 * `layout/theme.liquid` a partir de Theme settings > "Pedido mínimo e
 * descontos" (cents = 0 quando desativado).
 *
 * - Desabilita os botões de checkout do carrinho, drawer e notificação.
 * - Oculta os botões expressos (`additional_checkout_buttons`), que
 *   pularim a página do carrinho.
 * - Intercepta o submit para `/checkout` quando bloqueado e mostra o
 *   valor restante no `#cart-errors` / `#CartDrawer-CartErrors`.
 */

(function () {
  'use strict';

  if (window.SkafeMinimumOrder) return;

  var CONFIG = window.SkafeMinimumOrderConfig || {};
  var MINIMUM_SUBTOTAL_CENTS = typeof CONFIG.cents === 'number' ? CONFIG.cents : 0;

  var CHECKOUT_BUTTON_SELECTORS = [
    '#checkout',
    '#CartDrawer-Checkout',
    '#cart-notification-form [name="checkout"]',
  ];

  var DYNAMIC_BUTTON_SELECTORS = ['.additional-checkout-buttons', '.cart__dynamic-checkout-buttons'];

  function formatBRLFromCents(cents) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
  }

  function blockedMessage(missingCents) {
    var amount = formatBRLFromCents(missingCents);
    if (CONFIG.remaining) return CONFIG.remaining.replace('[amount]', amount);
    return 'Adicione mais ' + amount + ' em produtos para atingir o pedido mínimo de ' + formatBRLFromCents(MINIMUM_SUBTOTAL_CENTS) + '.';
  }

  function setButtonsBlocked(isBlocked) {
    CHECKOUT_BUTTON_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (btn) {
        if (isBlocked) {
          btn.setAttribute('disabled', '');
          btn.setAttribute('aria-disabled', 'true');
        } else {
          // Só reabilita se o carrinho não estiver vazio (Liquid cuida do vazio no SSR).
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
        }
      });
    });

    DYNAMIC_BUTTON_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.style.display = isBlocked ? 'none' : '';
        el.setAttribute('aria-hidden', isBlocked ? 'true' : 'false');
      });
    });
  }

  function showCartError(message) {
    var container = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (!container) return;
    container.textContent = message;
    container.setAttribute('role', 'alert');
    container.setAttribute('tabindex', '-1');
    if (container.focus) container.focus({ preventScroll: true });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('cart fetch failed');
        return res.json();
      })
      .then(function (cart) {
        return typeof cart.total_price === 'number' ? cart : null;
      })
      .catch(function () {
        return null;
      });
  }

  var refreshSequence = 0;

  function refreshCheckoutEligibility(cart) {
    if (!cart || typeof cart.total_price !== 'number') return false;
    var isBlocked = cart.item_count === 0 || cart.total_price < MINIMUM_SUBTOTAL_CENTS;
    setButtonsBlocked(isBlocked);
    return !isBlocked;
  }

  function refresh(cart) {
    var sequence = ++refreshSequence;
    if (cart && typeof cart.total_price === 'number') {
      return Promise.resolve(refreshCheckoutEligibility(cart));
    }
    return fetchCart().then(function (freshCart) {
      if (sequence !== refreshSequence || !freshCart) return false;
      return refreshCheckoutEligibility(freshCart);
    });
  }

  function checkoutSubmitter(form, eventSubmitter) {
    var submitter = eventSubmitter || form.elements.namedItem('checkout');
    if (!submitter || submitter.name !== 'checkout') return null;
    if (
      submitter.id !== 'checkout' &&
      submitter.id !== 'CartDrawer-Checkout' &&
      !submitter.closest('#cart-notification-form')
    ) {
      return null;
    }
    return submitter;
  }

  function resumeCheckout(form, submitter) {
    var currentForm = form.id ? document.getElementById(form.id) : form;
    var currentSubmitter = submitter.id ? document.getElementById(submitter.id) : submitter;
    if (!currentForm || !currentSubmitter || currentSubmitter.form !== currentForm) return;
    currentForm.dataset.skafeMinimumOrderAllowed = 'true';
    currentForm.requestSubmit(currentSubmitter);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.elements) return;
      var submitter = checkoutSubmitter(form, event.submitter);
      if (!submitter) return;
      if (form.dataset.skafeMinimumOrderAllowed === 'true') {
        delete form.dataset.skafeMinimumOrderAllowed;
        return;
      }
      // Confirma sempre o subtotal atual; o estado em memória pode estar atrasado
      // em relação a uma atualização Ajax do carrinho.
      event.preventDefault();
      event.stopPropagation();
      var sequence = ++refreshSequence;
      fetchCart().then(function (cart) {
        if (sequence !== refreshSequence) return;
        if (refreshCheckoutEligibility(cart)) {
          resumeCheckout(form, submitter);
          return;
        }
        var totalCents = cart ? cart.total_price : 0;
        var missing = Math.max(MINIMUM_SUBTOTAL_CENTS - totalCents, 0);
        showCartError(blockedMessage(missing));
      });
    },
    true
  );

  function subscribeToCartUpdates() {
    try {
      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
          refresh(event && event.cartData);
        });
      }
    } catch (e) {
      // PubSub indisponível — o refresh inicial + interceptação já cobrem.
    }
  }

  window.SkafeMinimumOrder = {
    MINIMUM_SUBTOTAL_CENTS: MINIMUM_SUBTOTAL_CENTS,
    refresh: refresh,
    refreshCheckoutEligibility: refreshCheckoutEligibility,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refresh();
      subscribeToCartUpdates();
    });
  } else {
    refresh();
    subscribeToCartUpdates();
  }
})();
